import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Media from 'reactstrap/lib/Media';
import Button from 'reactstrap/lib/Button';
import CustomModal from '../../../Components/Components/Modal';

import Gift from './Gift';

import coinImg from '../../../../../../images/redesign/common/coin.svg';
import { GIFTS_ITEMS, GIFTS_TAB, SCREEN_MODE, SCREENS } from '../../../../../../constants/constants';
import { UncontrolledTooltip } from 'reactstrap';
import { setUserScreenViewNew } from '../../../../../../actions/member';

class SendGift extends Component {
  static propTypes = {
    sendGift: PropTypes.func.isRequired,
    playButtonSound: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    gifts: PropTypes.shape(),
    players: PropTypes.shape(),
    notificationSettings: PropTypes.shape(),
    modalOpen: PropTypes.bool,
    roomId: PropTypes.string,
    giftPlayerUid: PropTypes.string,
    popularGifts: PropTypes.shape({}),
    screenMode: PropTypes.string,
    tournamentRoom: PropTypes.bool,
    disableDrinkGifts: PropTypes.bool,
  }

  static defaultProps = {
    gifts: {},
    players: {},
    notificationSettings: {},
    modalOpen: false,
    roomId: null,
    giftPlayerUid: null,
    popularGifts: {},
    screenMode: SCREEN_MODE.normal,
    disableDrinkGifts: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      giftId: '',
      sendingGift: false,
      giftSent: false,
      activeItem: 'popular',
    };
  }

  componentDidUpdate(prevProps) {
    const { setScreenViewNew } = this.props;
    if (this.props.modalOpen && !prevProps.modalOpen) {
      setScreenViewNew(SCREENS.ACTIVE_ROOM.GIFTS);
    }
  }

  sendGift = (giftId, drink) => {
    const {
      sendGift, roomId, playButtonSound, giftPlayerUid,
    } = this.props;
    const {
      sendingGift,
    } = this.state;

    this.setState({ confirmationModal: false });

    if (!sendingGift && giftPlayerUid && giftId) {
      playButtonSound();

      this.setState({ sendingGift: true });
      sendGift(roomId, giftId, [giftPlayerUid], drink).then((res) => {
        if (res === 'success') {
          this.setState({
            giftSent: true,
          });
          this.closeModal();
        }
        this.setState({ sendingGift: false });
      }).catch(() => {
        this.setState({ sendingGift: false });
      });
    }
  }

  closeModal = () => {
    const { toggle, playButtonSound } = this.props;

    playButtonSound();

    this.setState({
      giftId: '',
      giftSent: false,
      confirmationModal: false,
    });

    toggle(null, false);
  }

  startSendingGift = (giftId, drink) => {
    const { notificationSettings, playButtonSound } = this.props;
    playButtonSound();

    if (notificationSettings && notificationSettings.purchaseGift === false) {
      this.sendGift(giftId, drink);
    } else {
      this.setState({ giftId, drink });
      this.toggleConfirmModal(giftId, drink);
    }
  }

  toggleConfirmModal = (key, drink) => {
    const { gifts, drinkGifts } = this.props;
    const gift = drink ? drinkGifts[key] : gifts[key];

    this.setState(prevState => ({ 
      confirmationModal: !prevState.confirmationModal,
      totalPrice: gift?.price,
    }));
  }

  toggleActiveItem = (gift) => {
    const { activeItem } = this.state;

    if (gift === activeItem) return;

    this.setState({
      activeItem: gift
    })
  }

  render() {
    const {
      gifts,
      drinkGifts,
      t,
      modalOpen,
      popularGifts,
      screenMode,
      tournamentRoom,
      disableDrinkGifts,
    } = this.props;

    const {
      giftId,
      confirmationModal,
      totalPrice,
      giftSent,
      drink,
      activeItem,
    } = this.state;

    return (
      <div>
        <CustomModal
          addClassName="send-gifts-section"
          isOpen={modalOpen}
          toggle={this.closeModal}
          size="lg"
          width={650}
          title={t('gifts.gifts')}
          modalVerticalCentering
          body={(
            <div
              className="send-gifts-scrollarea"
              contentClassName="send-gifts-scrollarea-body"
              show
              rightOffset={16}
              topOffset={54}
              bottomOffset={-3}
            >
              <div className="send-gifts">
                <Row>
                  <Col className="text-center mb-2">
                    {t('gifts.buyAnyGift')}
                    <Media style={{ display: 'inline-block' }} src={coinImg} />
                  </Col>
                </Row>
                <Row>
                  <div className='d-flex flex-row no-wrap w-full justify-between px-3 gap-2'>
                    {GIFTS_TAB.map((item, idx) => (
                      <div key={idx} className={`d-flex align-items-center px-3 py-2 gift-tab-button-new-${screenMode} ${activeItem === item && `gift-tab-button-new-${screenMode}-active`}`} onClick={() => this.toggleActiveItem(item)}>
                        <span className='w-full break-word'>{t(`gifts.${item}`)}</span>
                      </div>
                    ))}
                  </div>
                </Row>
                <Row>
                  <Col xs="12">
                    <>
                      {activeItem === 'popular' ? (
                        <div style={{ maxWidth: '100%', width: '100%', padding: '15px' }}>
                          {popularGifts && Object.keys(popularGifts).map(key => (
                            <Fragment key={key}>
                              <Gift
                                id={key}
                                altClassName="gifts-gift-alt"
                                isSelected={giftId === popularGifts[key].name}
                                gift={popularGifts[key]}
                                selectGift={() => this.startSendingGift(key)}
                              />
                            </Fragment>
                          ))}
                        </div>
                      ) : (
                        <div style={{ maxWidth: '100%', width: '100%', padding: '15px' }}>

                          {GIFTS_ITEMS[activeItem] && GIFTS_ITEMS[activeItem].map((item, key) => {
                            if (!gifts[item]) return;

                            return (
                              <Fragment key={key}>
                                <Gift
                                  altClassName="gifts-gift-alt"
                                  id={gifts[item].name}
                                  isSelected={giftId === gifts[item].name}
                                  gift={gifts[item]}
                                  selectGift={() => this.startSendingGift(gifts[item].name)}
                                />
                              </Fragment>
                            )
                          })}
                          {activeItem === 'foodAndDrinks' && drinkGifts && !disableDrinkGifts && !tournamentRoom && Object.keys(drinkGifts).map(key => (
                            <Fragment key={`drinks-${key}`}>
                              <Gift
                                altClassName="gifts-gift-alt"
                                id={key}
                                popoverId={`drink-${key}`}
                                //  giftId={giftId}
                                isSelected={giftId === key}
                                gift={drinkGifts[key]}
                                selectGift={() => this.startSendingGift(key, true)}
                                isDrinkGift={true}
                              />
                              <UncontrolledTooltip
                                className="giftsHistory-tooltip player-receivedGift-tooltip-new player-receivedGift-tooltip-new-player-modal-right"
                                placement="top"
                                target={`drink-${key}`}
                                container={'div > div'}
                              >
                                {t('gifts.serveDrink')}
                              </UncontrolledTooltip>
                            </Fragment>
                          ))}
                        </div>
                      )}
                    </>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          footerClose
          footer={
            <Button className="modal-footer-button" onClick={this.closeModal}>
              {t('home.close')}
            </Button>
          }
        />

        <CustomModal
          isOpen={confirmationModal}
          toggle={this.toggleConfirmModal}
          size="md"
          verticalCentering
          largeText
          title={!giftSent ? t('gifts.gifts') : t('gifts.giftSent')}
          footerClose
          footer={(
            <>
              {
                !giftSent ? (
                  <Fragment>
                    <Button className="modal-footer-button" onClick={() => this.sendGift(giftId, drink)}>
                      {t('common.yes')}
                    </Button>
                    <Button className="modal-footer-button" onClick={this.toggleConfirmModal}>
                      {t('common.no')}
                    </Button>
                  </Fragment>
                ) : (
                  <Button className="modal-footer-button" onClick={this.toggleConfirmModal}>
                    {t('common.ok')}
                  </Button>
                )
              }
            </>
          )}
          body={(
            giftSent ? (
              <div className="send-gifts-confirmation">
                {t('gifts.sendGiftConfirm')}
              </div>
            ) : (
              <div className="send-gifts-confirmation">
                {`${t('gifts.confirmation')} ${totalPrice} ${t('gifts.coins')}­ `}
              </div>
            )
          )}
        />
      </div>
    );
  }
}


const mapStateToProps = state => ({
  gifts: state.rooms.gifts || {},
  drinkGifts: state.rooms.drinkGifts || {},
  popularGifts: state.rooms.popularGifts || {},
  players: state.game.players,
  playerVIPInfo: state.rooms.playerVIPInfo || null,
  offset: state.member.offset,
});

const mapDispatchToProps = {
  setScreenViewNew: setUserScreenViewNew
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(SendGift));
